import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/AppShell';
import { TodayView } from '@/features/today/TodayView';

export const Route = createFileRoute('/today')({
  component: TodayPage,
});

function TodayPage() {
  return (
    <AppShell>
      <TodayView />
    </AppShell>
  );
}
